import api from './axiosApi'
import type { ProcessingResponse } from '@/types'

/**
 * Download a dummy-SKU replacement template.
 * POST /skus/dummy-sku-template
 */
export async function downloadDummySkuTemplate(
  lineItemIds: string[]
): Promise<void> {
  const response = await api.post(
    '/skus/dummy-sku-template',
    { line_item_ids: lineItemIds },
    { responseType: 'blob' }
  )

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'dummy_sku_replacement_template.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

/**
 * Replace dummy SKU numbers from an uploaded template (async).
 * POST /plans/{plan_id}/replace-dummy-skus (multipart/form-data)
 * Returns 202 with ProcessingResponse — track progress via SSE on events_url.
 */
export async function replaceDummySkus(
  planId: string,
  file: File
): Promise<ProcessingResponse> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await api.post<ProcessingResponse>(
    `/plans/${planId}/replace-dummy-skus`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return response.data
}
